import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-navyDeep px-4 py-5 text-center md:px-12" data-id="element-77" data-mp="3gfiugihumbe4">
      <p className="font-heading text-[11px] font-extrabold uppercase text-white" data-id="element-78" data-mp="32nul2myzi10u">
        © 2026 Bright Digital Hub — All rights reserved.
      </p>
      <div className="mx-auto mt-1.5 max-w-[640px] space-y-1 text-[12px] leading-[1.4] text-white/70" data-id="element-79" data-mp="36q92r3qx2uqj">
        <p data-id="element-80" data-mp="3ugbpd4c2b8hr">
          Complete Orthopedic &amp; Trauma Toolkit™ provides professional educational reference materials and practical
          resources. It does not replace accredited medical education, individualized patient assessment, independent
          clinical judgment, current medical guidelines, institutional safety procedures, or professional licensing
          requirements.
        </p>
        <p data-id="element-81" data-mp="29xlz0k1buwgz">
          All clinical content must be independently reviewed and validated by qualified medical specialists before being
          distributed for clinical use.
        </p>
      </div>
      <nav aria-label="Legal" className="mt-1.5 text-[12px] text-white" data-id="element-82" data-mp="3labt60db0esh">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-83" data-mp="3gca5t38uhtb7" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-84" data-mp="3v89eog3s3xhe">•</span>}
            <a href={l.href} className="transition-colors duration-150 hover:text-gold" data-id="element-85" data-mp="3v5n6qfcz7fyn">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1 text-[12px] text-white" data-id="element-86" data-mp="81fnrqp54i1k">
        Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline hover:text-gold" data-id="element-87" data-mp="34p8v6p2nshq">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}